// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedParkingPosition_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.0001 11.9948C24.0001 15.4713 22.5218 18.6025 20.1594 20.794L18.6073 19.5006C20.6875 17.6681 21.9999 14.9846 21.9999 11.9944C21.9999 9.00438 20.6875 6.32082 18.6074 4.48833L20.1591 3.19528C22.5216 5.38685 24.0001 8.51817 24.0001 11.9948ZM3.84282 3.20155C1.48038 5.39312 0.00195311 8.52439 0.00195311 12.001C0.00195311 15.4774 1.48024 18.6085 3.8425 20.8001L5.39445 19.5068C3.3143 17.6743 2.00193 14.9907 2.00193 12.0006C2.00193 9.01054 3.31426 6.32699 5.39436 4.4945L3.84282 3.20155ZM17.9998 12.0006C17.9998 15.3143 15.3136 18.0005 11.9999 18.0005C8.6862 18.0005 5.99994 15.3143 5.99994 12.0006C5.99994 8.68694 8.6862 6.00067 11.9999 6.00067C15.3136 6.00067 17.9998 8.68694 17.9998 12.0006ZM19.9998 12.0006C19.9998 16.4188 16.4181 20.0005 11.9999 20.0005C7.58165 20.0005 3.99996 16.4188 3.99996 12.0006C3.99996 7.58238 7.58165 4.00069 11.9999 4.00069C16.4181 4.00069 19.9998 7.58238 19.9998 12.0006ZM9.6869 16.0005V8.82852H12.1509C12.5469 8.82852 12.9172 8.86886 13.2619 8.94952C13.6065 9.02285 13.9072 9.15119 14.1639 9.33452C14.4205 9.51052 14.6222 9.74885 14.7689 10.0495C14.9228 10.3428 14.9998 10.7058 14.9998 11.1385C14.9998 11.5565 14.9228 11.9195 14.7689 12.2275C14.6222 12.5355 14.4205 12.7885 14.1639 12.9865C13.9072 13.1845 13.6102 13.3311 13.2729 13.4265C12.9355 13.5218 12.5762 13.5695 12.1949 13.5695H11.3039V16.0005H9.6869ZM11.3039 12.2825H12.0959C12.9759 12.2825 13.4159 11.9012 13.4159 11.1385C13.4159 10.7645 13.2985 10.5005 13.0639 10.3465C12.8292 10.1925 12.4919 10.1155 12.0519 10.1155H11.3039V12.2825Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedParkingPosition is a generated icon component.
 */
let IconMedParkingPosition = IconMedParkingPosition_1 = class IconMedParkingPosition extends IconBaseElement {
    render() {
        return html `${IconMedParkingPosition_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedParkingPosition.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedParkingPosition = IconMedParkingPosition_1 = __decorate([
    customElement('zui-icon-med-parking-position')
], IconMedParkingPosition);
export { IconMedParkingPosition };
